import z from 'zod';
import { emailSchema } from './others';
import { tokenRegEx } from './validation';

// export const RoleChangeDialogSchema = z.object({
//     email: emailSchema,
//     password: z.string().min(1, {message: "Password is required"}).optional(),
//     token: z.string().regex(tokenRegEx, {
//         message:"Please provide correct token."
//     }).optional()
// });
export const RoleChangeDialogSchema = z.object({
  email: emailSchema,
  password: z
    .string()
    .min(1, { message: 'Password is required' })
    .optional()
    .or(z.literal('')), // allows "" as "not provided"
  token: z
    .string()
    .regex(tokenRegEx, { message: 'Please provide correct token.' })
    .optional()
    .or(z.literal('')), // allows "" as "not provided"
});
